webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Output_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Main_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_More_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_converter_vue__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*Импорт компонентов.*/




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  components: { myOutput: __WEBPACK_IMPORTED_MODULE_0__components_Output_vue__["a" /* default */], myMain: __WEBPACK_IMPORTED_MODULE_1__components_Main_vue__["a" /* default */], more: __WEBPACK_IMPORTED_MODULE_2__components_More_vue__["a" /* default */], converter: __WEBPACK_IMPORTED_MODULE_3__components_converter_vue__["a" /* default */] },
  data: function data() {
    return {
      showOne: true, //Переключатель элементов
      width: 0, //Ширина окна вывода
      findText: '0', //Вывод примера на экран
      ansText: '', //Вывод предварительного ответа
      classSwitch: true, //Переключатель темы
      count: 0, //Количество символов, выодимых на экран
      mode: true, //Режим работы приложения
      total: 0, //Курс выбранных валют
      val1: "", //Валюта: вход
      val2: "", //Валюта: выход
      mark1: "", //Знак валюты: вход
      mark2: "", //Знак валюты: выход
      config: {
        output: '', //Хранилище примера
        find: '', //Хранилище ответа
        ent: false, //Была ли вызвана функция Ok()
        fact: '' //Число для вычисления факториала
      },
      TestNum: 0 //Вспомогательная переменная
    };
  },

  computed: {
    arrow: function arrow() {
      /*Переменная, отвечающая за отображение блока #more_hide
      на экранах, больших 700px.*/
      return this.width < 700;
    },
    show: function show() {
      /*Переменная, отвечающая за отображение элемента #common.
      True - если область просмотра больше 700px или #more_hide
      в режиме toCommon.*/
      return !this.arrow || this.showOne;
    },
    pc: function pc() {
      /*Переменная, отвечающая за отображение элемента #more.
      True - если область просмотра больше 700px или #more_hide
      в режиме toMore.*/
      return !this.arrow || !this.showOne;
    }
  },
  watch: {
    mode: function mode(newVal, oldVal) {
      this.showOne = true;
      document.querySelector(".line").classList.toggle("move");
    }
  },
  methods: {
    update: function update(data) {
      /*Функция, вызываемая дочерним компонентом my-main.
      Получает на вход переменные дочернего компонента,
      обновляет значени локальных переменных, после чего
      вызывает метод,обновляющий значения на экране.*/
      this.config.output = data.output;
      this.config.find = data.find;
      this.config.ent = data.ent;
      this.config.fact = data.fact;
      if (!data.out) {
        this.outputGo();
      }
    },
    updateTotal: function updateTotal(data) {
      /*Функция обновления курса валют*/
      this.total = data.total;
    },
    updateVal: function updateVal(data) {
      /*Функция обновления значений валют для двусторонней связи*/
      this.val1 = data.val1;
      this.val2 = data.val2;
      this.mark1 = data.mark1;
      this.mark2 = data.mark2;
    },
    updateMode: function updateMode(data) {
      /*Функция, переключающая режим работы приложения*/
      this.mode = data.mode;
    },
    EvalFix: function EvalFix(n) {
      /*Вспомогательная функция для исправление ошибки потери
      байтов при вычислении ответа.*/
      if (eval(n).toString().length < eval(this.config.find).toString().length && eval(n).toString().length < eval(this.TestNum).toString().length) {
        this.TestNum = n;
      }
    },
    hardEvalFix: function hardEvalFix() {
      /*Функция исправление ответов с потерянными/добавленными 
      байтами в случаях несоответствия ответов из-за более чем
      одного символа.*/
      var count = 1;
      var ln = 1;
      var sym = "";
      var newTestNum = "";
      var TimeNum = this.config.find;
      var fStr = eval(find).toString().slice(-count);
      try {
        while (fStr[0] != ".") {
          fStr = eval(this.config.find).toString().slice(-count);
          fStr[0] == "0" ? sym = "-" : sym = sym;
          fStr[0] == "9" ? sym = "" : sym = sym;
          count++;
          fStr[0] == "0" || fStr[0] == "9" ? ln = count : ln = ln;
        }
        var sumStr = Number("1" + "0".repeat(ln - 1)) - Number(eval(this.config.find).toString().slice(-ln + 1));
        fStr = fStr.slice(-ln + 1).toString();
        for (var i = -9; i < 9; i++) {
          if (sym == "-") {
            newTestNum = this.config.find + "+(-0." + "0".repeat(eval(this.config.find).toString().length - Number(fStr).toString().length - 2) + (Number(sym == "-" ? fStr : sumStr) + i).toString() + ")";
          } else {
            newTestNum = this.config.find + "+(0." + "0".repeat(eval(this.config.find).toString().length - 2 - (sym == "-" ? fStr : sumStr).toString().length) + (Number(sym == "-" ? fStr : sumStr) + i).toString() + ")";
          }
          eval(newTestNum).toString().length < eval(this.config.find).toString().length && eval(newTestNum).toString().length < eval(TimeNum).toString().length ? TimeNum = newTestNum : TimeNum = TimeNum;
        }
        if (TimeNum != this.config.find) {
          this.config.find = TimeNum;
        }
      } catch (e) {
        console.warn("[hardEvalFix]: Дана бесконечная дробь, вычисления прерваны!");
      }
    },
    opAdd: function opAdd(data) {
      /*Функция вызова метода operatorAdd из других компонентов*/
      this.$refs.main.operatorAdd(data.operator, data.func);
    },
    resize: function resize() {
      /*Функция, обновляющая вывод и значение переменной width
      при изменении ширины экрана.*/
      try {
        this.width = document.querySelector("#container").clientWidth;
        this.count = parseInt(document.querySelector("#find").clientWidth / 45);
        this.width >= 700 ? document.querySelector("#container").classList.add("pc") : document.querySelector("#container").classList.remove("pc");
        this.outputGo();
      } catch (e) {
        console.warn("[resize]: Ошибка!");
      }
    },
    blink: function blink() {
      /*Функция, реализующая "торможение" анимации "моргания курсора"
      при нажатии кнопок посредством временного удаления класса элемента.*/
      document.querySelector("#find").classList.remove("blink");
      setTimeout(function () {
        document.querySelector("#find").classList.add("blink");
      }, 200);
    },
    outputGo: function outputGo() {
      /*Функция выводит на экран не более чем this.count символов (ширина области ответа,
      поделённая на фиксированное значение ширины наибольшего символа - 45)
      При этом, выводятся this.count последних, если на экране пример,
      и this.count первых - если ответ.*/
      if (this.config.output.slice(-1) == "…" && this.config.output.length > parseInt(document.querySelector("#find").clientWidth / 45)) {
        this.findText = this.config.output.substring(0, parseInt(document.querySelector("#find").clientWidth / 45)) + "…";
      } else {
        this.config.output.length > parseInt(document.querySelector("#find").clientWidth / 45) ? this.findText = this.config.output.slice(-parseInt(document.querySelector("#find").clientWidth / 45)) : this.findText = this.config.output;
      }
      this.config.output.length == 0 ? this.findText = "0" : this.findText = this.findText;
      this.ansGo();
    },
    ansGo: function ansGo() {
      /*Функция выводит предварительный ответ в специальную область на
      экране. Ответ рассчитывается при помощи функции eval().
      Проверки на случай длинных ответов, а также Infinity и NaN.*/
      if (this.config.find.length >= 0) {
        this.ansText = "";
      }
      if (eval(this.config.find).toString().length >= 18) {
        /*Исправление ответов с потерянными/добавленными байтами*/
        this.TestNum = this.config.find;
        for (var i = 1; i < 10; i++) {
          var newTestNum = this.config.find + "+(0." + "0".repeat(eval(this.config.find).toString().length - 3) + i + ")";
          this.EvalFix(newTestNum);
          newTestNum = this.config.find + "+(-0." + "0".repeat(eval(this.config.find).toString().length - 3) + i + ")";
          this.EvalFix(newTestNum);
        }
        if (eval(this.config.find).toString().length - eval(this.TestNum).toString().length >= 3) {
          this.config.find = this.TestNum;
        } else {
          this.hardEvalFix();
        }
      }
      try {
        eval(this.config.find).toString().length > this.count + 3 ? stop = eval(this.config.find).toString().substring(0, this.count + 2) : stop = eval(this.config.find);
        [Infinity, NaN, -Infinity].includes(stop) ? this.ansText = "Error" : this.ansText = stop;
        if (this.total != 0 && !this.mode) {
          this.ansText = this.ansText * this.total;
          var newFind = this.ansText.toString().indexOf(".");
          if (newFind >= 0) {
            this.ansText = this.ansText.toString().substring(0, newFind + 3);
          }
        }
      } catch (e) {
        if (this.config.ent && this.config.output.length > this.count) {
          this.config.ent = false;
          this.config.output = this.config.output + "…";
          this.outputGo();
          this.config.output = "";
        } else {
          console.warn("[ansGo]: Ошибка!");
        }
      }
      this.blink();
    },
    moreHide: function moreHide() {
      /*Функция переключения статуса страницы,
      необходима для отображения дополнительных
      математических клавиш в мобильной версии приложения.*/
      this.classSwitch = !this.classSwitch;
      this.showOne = !this.showOne;
    }
  },
  mounted: function mounted() {
    /*Метод, предназначенный для отслеживания изменения ширины экрана.*/
    this.$nextTick(function () {
      window.addEventListener('resize', this.resize);
      this.width = document.querySelector("#container").clientWidth;
      this.count = parseInt(document.querySelector("#find").clientWidth / 45);
      this.width >= 700 ? document.querySelector("#container").classList.add("pc") : document.querySelector("#container").classList.remove("pc");
      var config = {
        duration: 300
      };
      //Эффект волн при нажатии
      Waves.attach('#output', ['waves-block', 'waves-classic']);
      Waves.init(config);
      //Отключение контекстного меню
      document.oncontextmenu = function () {
        return false;
      };
    });
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Output_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41244a69_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Output_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Output_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41244a69_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Output_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'myOutput',
	props: ['findText', 'ansText', 'mark1', 'mark2', 'mode'],
	data: function data() {
		return {
			dark: true,
			act: true
		};
	},

	methods: {
		modeChange: function modeChange(m) {
			/*Функция, переключающая режим работы приложения*/
			this.act = m;
			this.$emit('updateMode', {
				mode: m
			});
		},
		copyToClipboard: function copyToClipboard() {
			var _this = this;

			/*Функция вызывается при двойном клике на окно отображения примера.
   Предназначена для отключения встроенного поведения, копирования
   содержимого поля и отображения соответствующего сообщения пользователю.*/
			event.preventDefault();
			var input = document.createElement("input");
			input.classList.add("copyInput");
			input.value = this.findText;
			document.querySelector("#container").appendChild(input);
			navigator.clipboard.writeText(this.findText).then(function () {
				console.log("[Navigator]: clipboard write '" + _this.findText + "' success");
			}, function () {
				document.querySelector(".copyInput").select();
				var cs = document.execCommand('copy');
				console.log("[Document]: clipboard write '" + _this.findText + "'");
			});
			input.remove();
			document.querySelector("#copy").style.bottom = "20px";
			document.querySelector("#copy").style.opacity = 0.75;
			setTimeout(function () {
				document.querySelector("#copy").style.opacity = 0;
			}, 750);
			setTimeout(function () {
				document.querySelector("#copy").style.bottom = "-200px";
			}, 1450);
		},
		light: function light() {
			/*Функция переключает тему сайта*/
			document.querySelector("*").classList.toggle("light") ? this.dark = false : this.dark = true;
		}
	}
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed498c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(43);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed498c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'myMain',
	props: ['findText', 'output', 'find', 'ent', 'fact', 'fix'],
	data: function data() {
		return {
			chk: false, //Вспомогательная переменная
			out: false, //Выводить ли ответ
			TestNum: 0, //Вспомогательная переменная
			newTestNum: "" //Вспомогательная переменная
		};
	},

	computed: {
		last: function last() {
			return this.find.toString().slice(-1);
		},
		last4: function last4() {
			return this.output.slice(-4);
		}
	},
	methods: {
		updateParent: function updateParent() {
			/*Функция обновленя родитльских данных вывода.*/
			this.$emit('update', {
				output: this.output,
				find: this.find,
				ent: this.ent,
				fact: this.fact,
				out: this.out
			});
		},
		deleteTest: function deleteTest() {
			/*Вспомогательная функция, удаляющая последствия работы
   функции newTest в том случае, если данная вставка мешает
   корректной работе приложения в дальнейшем.*/
			if (this.find.toString().slice(-1) == ")") {
				this.TestNum = this.find;
				this.newTestNum = "";
				while (["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", ")", "("].includes(this.TestNum.slice(-1))) {
					this.newTestNum = this.TestNum.slice(-1) + this.newTestNum;
					this.TestNum = this.TestNum.substring(0, this.TestNum.length - 1);
				}
				if (this.TestNum.slice(-2) == "(-") {
					this.newTestNum = "(-" + this.newTestNum;
				}
				if (this.newTestNum.substring(0, 1) == "(" && (this.TestNum.slice(-1) == "+" || this.TestNum.slice(-3) == "+(-")) {
					this.find = this.find.substring(0, this.find.length - this.newTestNum.length - 2);
					this.updateParent();
				}
			}
		},
		newNum: function newNum() {
			/*Вспомогательная функция, извлекающая число для проверки
   на возможность добавить вчисло плавующую точку.*/
			var n = 0;
			var nm = "";
			while (["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "."].includes(this.output.substring(this.output.length - 1 - n, this.output.length - n))) {
				nm = this.output.substring(this.output.length - 1 - n, this.output.length - n) + nm;
				n += 1;
			}
			return nm;
		},

		//Функции кнопок
		numAdd: function numAdd(num) {
			/*Функция вывода чисел на экран*/
			this.chk = this.find;
			this.deleteTest();
			this.chk = this.chk == this.find;
			if (!this.chk) {
				this.find += this.output.slice(-1);
			}
			if (this.find.toString().slice(-1) != ")" && !["e", "π", "!"].includes(this.output.slice(-1))) {
				if (this.output == "0") {
					this.output = this.find = "";
				}
				this.output += num;
				this.find += num;
				this.fact += num;
				this.out = false;
				this.updateParent();
			}
		},
		Zero: function Zero() {
			/*Функция обрабатывает число "0" и запускает функцию numAdd().
   Если последний символ не "." или число, то после нуля дописывается ".".*/
			this.chk = this.find;
			this.deleteTest();
			this.chk = this.chk == this.find;
			if (!this.chk) {
				this.find += this.output.slice(-1);
			}
			this.chk = this.newNum();
			this.chk = this.chk.toString().indexOf(".") >= 0;
			if (this.chk || ["0", "9", "8", "7", "6", "5", "4", "3", "2", "1", "."].includes(this.last)) {
				this.numAdd("0");
			} else if (["e", "π"].includes(this.output.slice(-1)) || this.output.slice(-1) == ")") {
				console.warn("[Zero]: Ошибка");
			} else {
				this.find == "" ? this.output = "0." : this.output += "0.";
				this.find += "0.";
				this.fact += "0.";
				this.out = false;
				this.updateParent();
			}
		},
		Dot: function Dot() {
			/*Функция добавляет в выражение плавающую точку.
   Если точка - первый символ числа, на экран выводится "0.".*/
			this.chk = this.find;
			this.deleteTest();
			this.chk = this.chk == this.find;
			if (!this.chk) {
				this.find += this.output.slice(-1);
			}
			var f = parseInt(this.last, 10);
			this.chk = this.newNum();
			this.chk = this.chk.toString().indexOf(".") >= 0;
			if (!this.chk && !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default()(f)) {
				this.operatorAdd(".", ".");
				this.fact += ".";
			} else if (!this.chk && this.find == "" && this.output == "0") {
				this.output += ".";
				this.find += "0.";
				this.fact += ".";
				this.output;
			} else if (!this.chk && this.output.slice(-1) != ")" && !["e", "π"].includes(this.output.slice(-1))) {
				this.output += "0.";
				this.find += "0.";
				this.fact += "0.";
				this.out = false;
			}
			this.fact.indexOf(".") == -1;
			this.updateParent();
		},
		operatorAdd: function operatorAdd(operator, func) {
			/*Функция получает на вход математический оператор, выводимый на экран,
   и его вычисляемый аналог для подстановки в find.*/
			if (this.output.slice(-1) == "^") {
				this.find = this.find.substring(0, this.find.length - 1);
			}
			if (func == "**") {
				this.chk = this.find;
				this.deleteTest();
				if (this.chk != this.find) {
					this.find += this.output.slice(-1);
				}
			}
			try {
				this.chk = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(eval(this.last));
			} catch (c) {
				this.chk = false;
			}
			/*Оператор выводится на экран, если перед ним стояло число,
   в противном случае оператор может заменять собой
   предыдущий.*/
			if (this.chk || this.last == ")") {
				this.output += operator;
				this.find += func;
			} else if (this.find == "" && this.findText == "0" && operator == "-") {
				this.find = this.output = "-";
			} else if (this.find == "" && (this.findText == "0" || this.findText == "false" || this.findText == "true")) {
				this.output = "0" + operator;
				this.find = "0" + func;
			} else if (this.find == "") {
				this.output = this.findText + operator;
				this.find = this.findText + func;
			} else if (this.last == "=") {
				this.output = this.output.substring(0, this.output.length - 1) + operator;
				this.find = this.find.substring(0, this.find.length - 2) + func;
			} else if (this.last == "(") {
				console.warn("[operatorAdd]: Ошибка!");
			} else if (!["+", "-", "*", "^", "/", "."].includes(this.last) || operator == "." && this.newNum().toString().indexOf(".") == -1) {
				this.output += operator;
				this.find += func;
			} else if (["+", "-", "*", "^", "/", "."].includes(this.last) && this.findText != "-") {
				this.output = this.output.substring(0, this.output.length - 1) + operator;
				this.find = this.find.substring(0, this.find.length - 1) + func;
			} else if (["+", "-", "*", "^", "/", "."].includes(this.last)) {
				this.output = "0" + operator;
				this.find = "0" + func;
			} else if (func == "**") {
				this.output += operator;
				this.find += func;
			}
			if (func != ".") {
				this.fact = "";
			}
			this.out = false;
			this.updateParent();
		},
		scAdd: function scAdd(input) {
			/*Функция получает на вход символ скобки "(" или ")"*/
			try {
				this.chk = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(eval(this.last));
			} catch (e) {
				this.chk = false;
			}
			/*Скобка ставится, если последний символ равен входному 
   или является числом.
   Закрывающих скобок не может быть больше, чем открывающих.*/
			if (input == "(" && !this.chk && ![".", ")"].includes(this.last)) {
				this.find == "" ? this.output = input : this.output += input;
				this.find += input;
			}
			if (input == ")" && (this.chk || this.last == ")") && this.last != "." && this.output.split("(").length - 1 > this.output.split(")").length - 1) {
				this.output += input;
				this.find += input;
			}
			this.out = false;
			this.updateParent();
			this.fact = "";
		},
		Clear: function Clear() {
			/*Очистка экрана*/
			this.find = this.fact = "";
			this.copy = this.output = "0";
			this.out = false;
			this.updateParent();
		},
		Ok: function Ok() {
			/*Вывод на экран ответа из дополнительной строки, очистка*/
			if (this.find != "" || document.querySelector("#ans").innerText == "false") {
				if (document.querySelector("#ans").innerText != "Error") {
					this.output = String(eval(this.find));
				} else if (this.find == "") {
					console.warn("[Ok]: Ошибка!");
				} else {
					this.output = "";
				}
				this.find = "";
				this.ent = true;
				this.out = false;
				this.updateParent();
				this.out = true;
				this.ent = false;
				this.fact = this.output = "";
				this.updateParent();
			}
		},
		findDEL: function findDEL() {
			/*Вспомогательная функция для функции Del(),
   осуществляющая удаление элементов сложных чисел в поле ответа.*/
			while (["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(this.find.toString().slice(-1))) {
				this.find = this.find.substring(0, this.find.length - 1);
			}
		},
		Del: function Del() {
			/*Issue: требуется рефакторинг*/
			this.chk = this.find;
			this.deleteTest();
			this.chk = this.chk == this.find;
			if (["!"].includes(this.output.slice(-1))) {
				/*Если удаляется факториал: 
    1. Удаляется его числовое значениеиз переменной find 
    (в том числе большие числа вида a.b...e+... ,
    где e - константа, a и b - целые числа).
    2. Последовательной проверкой каждого символа строки ввода
    (справа налево) на принадлежность его к массиву целых чисел 
    находится и вносится в переменную значение исходного числа.
    3.Обновляются все связанные переменные.*/
				this.findDEL();
				if (this.find.toString().slice(-2) == "e+") {
					this.find = this.find.substring(0, this.find.length - 2);
					this.findDEL();
					if (this.last == ".") {
						this.find = this.find.substring(0, this.find.length - 1);
						this.findDEL();
					}
				}
				var n = 0;
				var nm = "";
				this.output = this.output.substring(0, this.output.length - 1);
				while (["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(this.output.substring(this.output.length - 1 - n, this.output.length - n))) {
					nm = this.output.substring(this.output.length - 1 - n, this.output.length - n) + nm;
					n += 1;
				}
				this.output = this.output + "!";
				this.find += nm;
				this.fact = nm;
				/*В последующих условиях удаляется необходимое количество символов
    из переменных find и output в соответствии с удаляемой функцией.*/
			} else if (!this.chk) {
				console.log("[deleteTest]: Success!");
			} else if (this.output.slice(-1) == "π" || this.output.slice(-1) == "e") {
				this.find = this.find.substring(0, this.find.length - 17);
			} else if (this.last in ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "."]) {
				this.find = this.find.substring(0, this.find.length - 1);
				this.fact = this.fact.substring(0, this.fact.length - 1);
			} else if (this.last == "=") {
				this.find = this.find.substring(0, this.find.length - 2);
			} else if (["1/Math.tan("].includes(this.find.toString().slice(-11))) {
				this.find = this.find.substring(0, this.find.length - 11);
				this.output = this.output.substring(0, this.output.length - 3);
			} else if (["sin(", "cos(", "tan("].includes(this.last4)) {
				this.find = this.find.substring(0, this.find.length - 9);
				this.output = this.output.substring(0, this.output.length - 3);
			} else if (["log("].includes(this.last4)) {
				this.find = this.find.substring(0, this.find.length - 11);
				this.output = this.output.substring(0, this.output.length - 3);
			} else if (["ln("].includes(this.output.slice(-3))) {
				this.find = this.find.substring(0, this.find.length - 9);
				this.output = this.output.substring(0, this.output.length - 2);
			} else if (["√("].includes(this.output.slice(-2))) {
				this.find = this.find.substring(0, this.find.length - 10);
				this.output = this.output.substring(0, this.output.length - 1);
			} else if (["^"].includes(this.output.slice(-1))) {
				this.find = this.find.substring(0, this.find.length - 2);
			} else {
				this.find = this.find.substring(0, this.find.length - 1);
			}
			if (this.output.slice(-2) == "0.") {
				this.find = this.find.substring(0, this.find.length - 1);
				this.output = this.output.substring(0, this.output.length - 1);
			}
			this.output = this.output.substring(0, this.output.length - 1);
			this.out = false;
			this.fact = "";
			this.updateParent();
		}
	}
});

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'more',
	props: ['output', 'find', 'ent', 'fact'],
	computed: {
		last: function last() {
			return this.output.slice(-1);
		},
		last1: function last1() {
			return this.find.slice(-1);
		}
	},
	methods: {
		updateParent: function updateParent() {
			/*Функция обновления родитльских данных вывода.*/
			this.$emit('update', {
				output: this.output,
				find: this.find,
				ent: this.ent,
				fact: this.fact
			});
		},
		operatorAdd: function operatorAdd(operator, func) {
			/*Функция, вызывающая метод operatorAdd.*/
			this.$emit('opAdd', {
				operator: operator,
				func: func
			});
		},
		cnstAdd: function cnstAdd(p, f) {
			/*Функция получает на вход константу и её вычисляемый аналог в JS.
   Подстановка происходит, если последний символ - не число.*/
			if (this.last == "^") {
				this.find = this.find.substring(0, this.find.length - 1);
			}
			if (["=", ">", "<", "-", "+", "/", "*", "", "("].includes(this.last1) && this.last1 != "") {
				this.output += p;
				this.find += f;
				this.fact = "";
				this.updateParent();
			} else if (this.output == "" || this.output == "0") {
				this.output = p;
				this.find = f;
				this.fact = "";
				this.updateParent();
			}
		},
		newNum: function newNum() {
			/*Вспомогательная функция, извлекающая число для вычисления факториала,
   в случае если переменная fact пуста.*/
			var n = 0;
			var nm = "";
			while (["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "."].includes(this.output.substring(this.output.length - 1 - n, this.output.length - n))) {
				nm = this.output.substring(this.output.length - 1 - n, this.output.length - n) + nm;
				n += 1;
			}
			return nm;
		},
		fAdd: function fAdd() {
			/*Функция проверяет возможность вычисления факториала и вызывает 
   функцию factorial(n) в случае успеха.*/
			if (this.output == "") {
				this.output = this.findText;
				var nm = this.newNum();
				if (nm != "0") {
					this.fact = nm;
				}
				if (this.output.substring(0, 1) == "-") {
					this.find = "-";
				}
			}
			if (this.fact == "" && ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "."].includes(this.output.slice(-1))) {
				this.fact = this.newNum();
			}
			if (this.fact.indexOf(".") == -1 && this.last != "." && this.last != "!") {
				this.output += "!";
				this.find = this.find.substring(0, this.find.length - this.fact.length) + String(this.factorial(this.fact));
				this.fact = "";
			}
			this.updateParent();
		},
		factorial: function factorial(n) {
			/*Рекурсивная функция вычисления факториала, получает на вход
   число n, для которого высчитывается факториал.*/
			try {
				return n != 1 ? n * this.factorial(n - 1) : 1;
			} catch (e) {
				return "Error";
			}
		}
	},
	mounted: function mounted() {
		var config = {
			duration: 300
		};
		//Эффект волн при нажатии
		Waves.attach('#output', ['waves-block', 'waves-classic']);
		Waves.attach('.moreButton', ['waves-block', 'waves-classic']);
		Waves.init(config);
	}
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Main_vue__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'converter',
	components: { myMain: __WEBPACK_IMPORTED_MODULE_0__Main_vue__["a" /* default */] },
	props: ['findText', 'output', 'find', 'ent', 'fact', 'total', 'val1', 'val2', 'mark1', 'mark2'],
	data: function data() {
		return {
			key: "9116ea120a47ab05aa695a9c3199d1437def2d53" //Ключ для обращения к API
		};
	},

	computed: {
		url: function url() {
			/*Переменная, хранящая URL, необходимый для доступа к API*/
			return "https://api.getgeoapi.com/v2/currency/convert?api_key=" + this.key + "&from=" + this.val1 + "&to=" + this.val2 + "&amount=1&format=json";
		},
		currency: function currency() {
			/*Получение валют*/
			return curData;
		}
	},
	watch: {
		val1: function val1(newVal, oldVal) {
			var sel = document.querySelector("#in");
			if (oldVal != this.val2 || oldVal == "") {
				this.mark1 = sel.options[sel.selectedIndex].text.slice(-1);
			}
			if (newVal != oldVal && this.val2 != 0) {
				this.apiGo();
			}
			this.updateVal();
		},
		val2: function val2(newVal, oldVal) {
			var sel = document.querySelector("#out");
			if (oldVal != this.val1 || oldVal == "") {
				this.mark2 = sel.options[sel.selectedIndex].text.slice(-1);
			}
			if (newVal != oldVal && this.val1 != 0) {
				this.apiGo();
			}
			this.updateVal();
		}
	},
	methods: {
		updateParent: function updateParent() {
			/*Функция обновления родитльских данных вывода.*/
			this.$emit('update', {
				output: this.output,
				find: this.find,
				ent: this.ent,
				fact: this.fact
			});
		},
		updateTotal: function updateTotal(total) {
			/*Функция обновления курса выбранных валют*/
			this.$emit('updateT', {
				total: total
			});
			this.updateParent();
		},
		updateVal: function updateVal() {
			/*Функция обновления выбранных валют*/
			this.$emit('updateVal', {
				val1: this.val1,
				val2: this.val2,
				mark1: this.mark1,
				mark2: this.mark2
			});
		},
		apiGo: function apiGo() {
			var _this = this;

			fetch(this.url).then(function (response) {
				return response.json();
			}).then(function (data) {
				_this.updateTotal(data['rates'][_this.val2]['rate']);
			}).catch(function (error) {
				return console.warn("[apiGo]: Ошибка!");
			});
		},
		swap: function swap() {
			var _ref = [this.val2, this.val1];
			/*Функция, меняющая конвертируемые валюты местами*/

			this.val1 = _ref[0];
			this.val2 = _ref[1];
			var _ref2 = [this.mark2, this.mark1];
			this.mark1 = _ref2[0];
			this.mark2 = _ref2[1];

			var doubleArrow = document.querySelector("#doubleArrow");
			doubleArrow.style.transform == "rotate(0deg)" ? doubleArrow.style.transform = "rotate(360deg)" : doubleArrow.style.transform = "rotate(0deg)";
			this.apiGo();
		}
	},
	mounted: function mounted() {
		document.querySelector("#doubleArrow").style.transform = "rotate(0deg)";
		this.$nextTick(function () {
			this.find = this.fact = "";
			this.ent = false;
			this.output = "0";
			this.updateParent();
		});
	},
	beforeDestroy: function beforeDestroy() {
		this.find = this.fact = "";
		this.ent = false;
		this.output = "0";
		this.updateParent();
	}
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Output_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(52);




__webpack_require__(54);
__webpack_require__(56);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.silent = true;
stop = "";

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
	components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
	template: '<App/>'
});

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a43bd36_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(50);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a43bd36_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"output"},on:{"dblclick":_vm.copyToClipboard}},[_c('div',{attrs:{"id":"switch"}},[(_vm.dark)?_c('img',{staticClass:"swh",attrs:{"src":__webpack_require__(22),"alt":"switch"},on:{"click":_vm.light}}):_c('img',{staticClass:"swh",attrs:{"src":__webpack_require__(23),"alt":"switch","rel":"preload"},on:{"click":_vm.light}})]),_vm._v(" "),_c('div',{attrs:{"id":"mode"}},[_c('img',{class:{act: _vm.act},attrs:{"src":__webpack_require__(24),"alt":"calculator","id":"calcButton"},on:{"click":function($event){return _vm.modeChange(true)}}}),_vm._v(" "),_c('img',{class:{act: !_vm.act},attrs:{"src":__webpack_require__(25),"alt":"currecy","id":"currencyButton"},on:{"click":function($event){return _vm.modeChange(false)}}})]),_vm._v(" "),_c('span',{staticClass:"blink",attrs:{"id":"find"}},[_vm._v(_vm._s(_vm.findText)+_vm._s(!_vm.mode ? _vm.mark1 : ""))]),_vm._v(" "),_c('span',{attrs:{"id":"ans"}},[_vm._v(_vm._s(!_vm.mode && _vm.ansText == "" ? "0" : _vm.ansText)+_vm._s(!_vm.mode ? _vm.mark2 : ""))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/light.fd00639.svg";

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDIwMDEwOTA0Ly9FTiIKICJodHRwOi8vd3d3LnczLm9yZy9UUi8yMDAxL1JFQy1TVkctMjAwMTA5MDQvRFREL3N2ZzEwLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4wIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiB3aWR0aD0iMTU0OS4wMDAwMDBwdCIgaGVpZ2h0PSIyMDUwLjAwMDAwMHB0IiB2aWV3Qm94PSIwIDAgMTU0OS4wMDAwMDAgMjA1MC4wMDAwMDAiCiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCBtZWV0Ij4KCjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLDIwNTAuMDAwMDAwKSBzY2FsZSgwLjEwMDAwMCwtMC4xMDAwMDApIgpmaWxsPSIjMDAwMDAwIiBzdHJva2U9Im5vbmUiPgo8cGF0aCBkPSJNOTY0NSAyMDQ5MCBjLTE3NTggLTU1IC0zNDY0IC02MDMgLTQ5NjUgLTE1OTUgLTEyNDIgLTgyMSAtMjMzNgotMTk3MCAtMzEyMSAtMzI4MCAtODI5IC0xMzgyIC0xMzQxIC0yOTM2IC0xNDk4IC00NTQ2IC02MiAtNjMxIC03MyAtMTI4MyAtMzEKLTE4MjkgMTU0IC0xOTg0IDkwNSAtMzgzMSAyMTk2IC01NDAwIDI0NiAtMjk5IDUxNSAtNTg2IDgzOSAtODk3IDE4MDkgLTE3MzIKNDI4MCAtMjc4NSA2ODYwIC0yOTIyIDQ5NSAtMjcgNTUyIC0yNiAxMDcwIDE4IDk3MCA4MyAxMzY2IDEzMiAxODI1IDIyNiA0MzIKODkgODQ4IDIxNiAxMTg2IDM2MiAyNTEgMTA4IDE0NjMgNjg4IDE0NDUgNjkxIC0xMSAyIC0zMzQgLTExIC03MTggLTI5IC0xMTM4Ci01MyAtMTQ2NCAtNDMgLTIwNzMgNjIgLTIzOTkgNDE0IC00NjMyIDIyNzEgLTU3NDMgNDc3NSAtNjkgMTU1IC04NSAyMDEgLTg5CjI1NCAtNCA1MSAtMjYgMTE2IC0xMDEgMzA1IC0yOTAgNzI4IC00NjQgMTQyOCAtNTU2IDIyMzUgLTQ2IDQwNiAtNjEgNjgzIC02MQoxMTY2IDAgNTEwIDE4IDgyMSA3NiAxMjgzIDMzMCAyNjUxIDE3NDAgNTAxOCAzNzk5IDYzNzcgMTA4NiA3MTYgMjI1NiAxMTEyCjM1MzAgMTE5NCA4OCA1IDQ5MyAxMCA4OTkgMTAgNDEyIDAgNzM2IDQgNzMxIDkgLTIwIDE4IC0xMDc1IDU4NyAtMTI1MyA2NzUKLTkyMCA0NTkgLTE5MzcgNzM5IC0zMDIyIDgzMCAtMzkxIDM0IC03NDAgNDEgLTEyMjUgMjZ6IG0xMTQ1IC02MDQgYzY3MCAtNTgKMTI1OCAtMTc0IDE4MzUgLTM2MyBsMjAwIC02NiAtMTcwIC0yOSBjLTIxMjggLTM2MiAtNDA2MCAtMTY0MCAtNTM4MSAtMzU1OAotMTMwMyAtMTg5MiAtMTkxMiAtNDI1MCAtMTcxOCAtNjY2MCA3OCAtOTc1IDI4NCAtMTg4MCA2MTcgLTI3MTAgNDggLTExOSA3MwotMTk2IDc4IC0yNDAgMTAgLTg1IDI1IC0xMjcgMTI3IC0zNjAgMjc1IC02MjYgNjUwIC0xMjY2IDEwNzIgLTE4MjkgMjkxIC0zODgKNTE5IC02NTAgODc1IC0xMDA3IDQ1OCAtNDU4IDg1NCAtNzg0IDEzNjAgLTExMTkgNjE3IC00MDggMTIxMCAtNjk3IDE4ODgKLTkyMSAyMjQgLTczIDY1MyAtMTg4IDgwNiAtMjE1IDUyIC05IDY4IC0xNSA1NCAtMjAgLTMzIC0xMiAtNDM1IC02NyAtNjg4Ci05NCAtMTMyIC0xNCAtNDU0IC00NCAtNzE1IC02NiAtNDU4IC0zOSAtNDg1IC00MSAtNzYwIC0zNSAtMTE3OSAyNCAtMjM4OAoyNjEgLTM0OTAgNjg1IC0yOTkwIDExNTIgLTUyMDcgMzU5OCAtNTkzNCA2NTQ3IC0xMzggNTU5IC0yMTUgMTA5MyAtMjQ3IDE3MDkKLTE0IDI3MCAtNiA4NjYgMTYgMTE2NSAxMDcgMTQ2NyA0OTMgMjgzNiAxMTU1IDQxMDAgMTAwNSAxOTE0IDI1ODMgMzQzMiA0NDcxCjQyOTkgMTAyOSA0NzIgMjExMCA3MzcgMzI2NCA4MDEgMjQ1IDEzIDEwNzIgNCAxMjg1IC0xNHoiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDIwMDEwOTA0Ly9FTiIKICJodHRwOi8vd3d3LnczLm9yZy9UUi8yMDAxL1JFQy1TVkctMjAwMTA5MDQvRFREL3N2ZzEwLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4wIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiB3aWR0aD0iMTI4LjAwMDAwMHB0IiBoZWlnaHQ9IjEyOC4wMDAwMDBwdCIgdmlld0JveD0iMCAwIDEyOC4wMDAwMDAgMTI4LjAwMDAwMCIKIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiPgoKPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsMTI4LjAwMDAwMCkgc2NhbGUoMC4xMDAwMDAsLTAuMTAwMDAwKSIKZmlsbD0iIzAwMDAwMCIgc3Ryb2tlPSJub25lIj4KPHBhdGggZD0iTTU3MCAxMTgxIGMwIC0yNSAtNSAtMzAgLTQyIC0zOSAtOTIgLTI0IC0xODIgLTEwNSAtMjEzIC0xOTIgLTIzCi02NCAtMTkgLTExOSAxMyAtMTgxIDMzIC02NiA4OCAtMTA5IDE3NiAtMTM5IGw2NiAtMjIgMCAtMTM0IDAgLTEzNSAtMjIgNwpjLTQyIDEyIC0xMDMgNDYgLTEyOSA3MSBsLTI2IDI0IC02MiAtNTEgYy0zMyAtMjggLTYxIC01NSAtNjEgLTYwIDAgLTMzIDE4MQotMTQyIDI2MSAtMTU1IDM1IC02IDM5IC0xMCAzOSAtMzYgMCAtMzAgMCAtMzAgNTMgLTI3IDQ4IDMgNTIgNSA1NSAzMCAzIDIxCjEwIDI4IDM1IDM0IDkxIDE5IDE5MSA5NiAyMzEgMTc3IDcwIDE0MCAtMTQgMzAxIC0xOTQgMzc0IGwtNzAgMjggMCAxMTQgMAoxMTMgMjggLTYgYzE1IC00IDQ5IC0yMCA3NSAtMzYgMjcgLTE3IDUyIC0zMCA1NiAtMzAgMyAwIDMxIDI1IDYxIDU1IGw1NCA1NQotMjQgMjUgYy0zMiAzNCAtMTI3IDgxIC0xOTUgOTYgLTUxIDExIC01NSAxNCAtNTUgNDEgMCAyNyAtMSAyOCAtNTUgMjggLTU0IDAKLTU1IC0xIC01NSAtMjl6IG04MiAtMjggYzMgLTI0IDkgLTI4IDY0IC0zOSA1OCAtMTIgMTM3IC00NyAxNzggLTc5IDE5IC0xNQoxOSAtMTUgLTUgLTQxIC00MSAtNDQgLTUzIC00NiAtMTA3IC0xOCAtMjcgMTQgLTY4IDI4IC05MSAzMSBsLTQxIDYgMCAtMTQxIDAKLTE0MCAzOCAtMTIgYzI3NCAtODggMzM4IC0zMzEgMTI0IC00NjkgLTI2IC0xNiAtNzIgLTM3IC0xMDIgLTQ0IC00OCAtMTIgLTU1Ci0xOCAtNTggLTQxIC0zIC0yMCAtOSAtMjYgLTI3IC0yNiAtMTggMCAtMjQgNiAtMjcgMjcgLTMgMjQgLTkgMjkgLTQzIDM0IC02NAoxMSAtMTQwIDQ0IC0xOTUgODQgLTI3IDIwIC01MCA0MCAtNTAgNDQgMCA0IDE4IDIyIDM5IDM5IGwzOSAzMiA1MiAtMzUgYzQ5Ci0zMyAxMDYgLTU1IDE0MyAtNTUgMTYgMCAxNyAxMiAxNSAxNjEgbC0zIDE2MCAtNjYgMjIgYy04MiAyOCAtMTQyIDY4IC0xNzIKMTE2IC0yOCA0NiAtMzAgMTQ5IC00IDE5OCAzOCA3MSAxMjMgMTM0IDIwNCAxNTEgMzEgNiAzOSAxMiA0MSAzNSAzIDIxIDkgMjcKMjcgMjcgMTggMCAyNCAtNiAyNyAtMjd6Ii8+CjxwYXRoIGQ9Ik01MzUgOTk0IGMtODMgLTQzIC0xMTcgLTExOCAtNzkgLTE3MyAxNiAtMjIgMTA2IC03MSAxMzIgLTcxIDkgMCAxMgozMyAxMiAxMzAgMCAxNDQgLTIgMTQ3IC02NSAxMTR6IG0zMSAtMjAxIGMtMyAtMyAtMjIgMyAtNDMgMTMgLTY5IDM0IC02NiAxMDMKNyAxNTIgbDM1IDIzIDMgLTkyIGMxIC01MCAxIC05NCAtMiAtOTZ6Ii8+CjxwYXRoIGQ9Ik02NTAgNDYxIGMwIC0xMzcgMiAtMTUxIDE4IC0xNTEgMzMgMSA5NyAzNyAxMzAgNzQgMzYgNDIgNDEgODIgMTYKMTI1IC0xOSAzMiAtOTcgODcgLTEzNiA5NyBsLTI4IDYgMCAtMTUxeiBtNjkgOTQgYzM5IC0yMCA4MSAtNzIgODEgLTk5IDAgLTMyCi0zNCAtNzMgLTgxIC05NiBsLTM5IC0yMCAwIDExNSBjMCA2MyAyIDExNSA1IDExNSA0IDAgMTkgLTcgMzQgLTE1eiIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"common"}},[_c('div',{staticClass:"button orange KeyC",on:{"click":function($event){return _vm.Clear()}}},[_vm._v("C")]),_vm._v(" "),_c('div',{staticClass:"button orange",attrs:{"id":"sc"},on:{"click":function($event){return _vm.scAdd('(')}}},[_vm._v("(")]),_vm._v(" "),_c('div',{staticClass:"button orange",attrs:{"id":"sc2"},on:{"click":function($event){_vm.scAdd(')')}}},[_vm._v(")")]),_vm._v(" "),_c('div',{staticClass:"button orange",attrs:{"id":"dl"},on:{"click":function($event){return _vm.operatorAdd('÷', '/')}}},[_vm._v("÷")]),_vm._v(" "),_c('div',{staticClass:"button num7",on:{"click":function($event){return _vm.numAdd('7')}}},[_vm._v("7")]),_vm._v(" "),_c('div',{staticClass:"button num8",on:{"click":function($event){return _vm.numAdd('8')}}},[_vm._v("8")]),_vm._v(" "),_c('div',{staticClass:"button num9",on:{"click":function($event){return _vm.numAdd('9')}}},[_vm._v("9")]),_vm._v(" "),_c('div',{staticClass:"button orange",attrs:{"id":"mn"},on:{"click":function($event){return _vm.operatorAdd('×', '*')}}},[_vm._v("×")]),_vm._v(" "),_c('div',{staticClass:"button num4",on:{"click":function($event){return _vm.numAdd('4')}}},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"button num5",on:{"click":function($event){return _vm.numAdd('5')}}},[_vm._v("5")]),_vm._v(" "),_c('div',{staticClass:"button num6",on:{"click":function($event){return _vm.numAdd('6')}}},[_vm._v("6")]),_vm._v(" "),_c('div',{staticClass:"button orange Minus NumpadSubtract",on:{"click":function($event){return _vm.operatorAdd('-', '-')}}},[_vm._v("–")]),_vm._v(" "),_c('div',{staticClass:"button num1",on:{"click":function($event){return _vm.numAdd('1')}}},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"button num2",on:{"click":function($event){return _vm.numAdd('2')}}},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"button num3",on:{"click":function($event){return _vm.numAdd('3')}}},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"button orange NumpadAdd Equal",attrs:{"id":"plus"},on:{"click":function($event){return _vm.operatorAdd('+', '+')}}},[_vm._v("+")]),_vm._v(" "),_c('div',{staticClass:"button num0",on:{"click":function($event){return _vm.Zero()}}},[_vm._v("0")]),_vm._v(" "),_c('div',{staticClass:"button Period Comma NumpadDecimal",on:{"click":function($event){return _vm.Dot()}}},[_vm._v(".")]),_vm._v(" "),_c('div',{staticClass:"button Backspace",on:{"click":function($event){return _vm.Del()}}},[_c('img',{attrs:{"src":__webpack_require__(44),"alt":"del","id":"del"}})]),_vm._v(" "),_c('div',{staticClass:"button Enter NumpadEnter",on:{"click":function($event){return _vm.Ok()}}},[_vm._v("=")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dl.4f48a2a.svg";

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_More_vue__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dac6cff_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_More_vue__ = __webpack_require__(46);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_More_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dac6cff_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_More_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"more"}},[_c('div',{staticClass:"moreButton",attrs:{"id":"equals"},on:{"click":function($event){return _vm.operatorAdd('=', '==')}}},[_vm._v("=")]),_vm._v(" "),_c('div',{staticClass:"moreButton",attrs:{"id":"n_equals"},on:{"click":function($event){return _vm.operatorAdd('≠', '!=')}}},[_vm._v("≠")]),_vm._v(" "),_c('div',{staticClass:"moreButton",attrs:{"id":"m_eqals"},on:{"click":function($event){return _vm.operatorAdd('≤', '<=')}}},[_vm._v("≤")]),_vm._v(" "),_c('div',{staticClass:"moreButton",attrs:{"id":"b_eqals"},on:{"click":function($event){return _vm.operatorAdd('≥', '>=')}}},[_vm._v("≥")]),_vm._v(" "),_c('div',{staticClass:"moreButton",attrs:{"id":"less"},on:{"click":function($event){return _vm.operatorAdd('<', '<')}}},[_vm._v("<")]),_vm._v(" "),_c('div',{staticClass:"moreButton",attrs:{"id":"mr"},on:{"click":function($event){return _vm.operatorAdd('>', '>')}}},[_vm._v(">")]),_vm._v(" "),_c('div',{staticClass:"moreButton KeyP",attrs:{"id":"pi"},on:{"click":function($event){return _vm.cnstAdd('π', Math.PI)}}},[_vm._v("π")]),_vm._v(" "),_c('div',{staticClass:"moreButton KeyE",attrs:{"id":"eps"},on:{"click":function($event){return _vm.cnstAdd('e', Math.E)}}},[_vm._v("e")]),_vm._v(" "),_c('div',{staticClass:"moreButton",attrs:{"id":"sin"},on:{"click":function($event){return _vm.cnstAdd('sin(', 'Math.sin(')}}},[_vm._v("sin")]),_vm._v(" "),_c('div',{staticClass:"moreButton",attrs:{"id":"cos"},on:{"click":function($event){return _vm.cnstAdd('cos(', 'Math.cos(')}}},[_vm._v("cos")]),_vm._v(" "),_c('div',{staticClass:"moreButton",attrs:{"id":"tg"},on:{"click":function($event){return _vm.cnstAdd('tan(', 'Math.tan(')}}},[_vm._v("tan")]),_vm._v(" "),_c('div',{staticClass:"moreButton",attrs:{"id":"ctg"},on:{"click":function($event){return _vm.cnstAdd('ctn(', '1/Math.tan(')}}},[_vm._v("ctn")]),_vm._v(" "),_c('div',{staticClass:"moreButton",attrs:{"id":"sqare"},on:{"click":function($event){return _vm.cnstAdd('√(', 'Math.sqrt(')}}},[_vm._v("√")]),_vm._v(" "),_c('div',{staticClass:"moreButton",attrs:{"id":"deg"},on:{"click":function($event){return _vm.operatorAdd('^', '**')}}},[_vm._v("xʸ")]),_vm._v(" "),_c('div',{staticClass:"moreButton",attrs:{"id":"pr"},on:{"click":function($event){return _vm.fAdd()}}},[_vm._v("x!")]),_vm._v(" "),_c('div',{staticClass:"moreButton",attrs:{"id":"log"},on:{"click":function($event){return _vm.cnstAdd('log(', 'Math.log10(')}}},[_vm._v("log")]),_vm._v(" "),_c('div',{staticClass:"moreButton",attrs:{"id":"ln"},on:{"click":function($event){return _vm.cnstAdd('ln(', 'Math.log(')}}},[_vm._v("ln")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_converter_vue__ = __webpack_require__(15);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_582cb242_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_converter_vue__ = __webpack_require__(48);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_converter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_582cb242_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_converter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"converterKeyboard"}},[_c('div',{staticClass:"move",attrs:{"id":"currencyChange"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.val1),expression:"val1"}],attrs:{"id":"in"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.val1=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":"","selected":""}},[_vm._v("Конвертировать из")]),_vm._v(" "),_vm._l((_vm.currency),function(item){return _c('option',{domProps:{"value":item.name}},[_vm._v(_vm._s(item.fullname)+", "+_vm._s(item.mark))])})],2),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(49),"alt":"swap","id":"doubleArrow","rel":"preload"},on:{"click":_vm.swap}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.val2),expression:"val2"}],attrs:{"id":"out"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.val2=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":"","selected":""}},[_vm._v("Конвертировать в")]),_vm._v(" "),_vm._l((_vm.currency),function(item){return _c('option',{domProps:{"value":item.name}},[_vm._v(_vm._s(item.fullname)+", "+_vm._s(item.mark))])})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDIwMDEwOTA0Ly9FTiIKICJodHRwOi8vd3d3LnczLm9yZy9UUi8yMDAxL1JFQy1TVkctMjAwMTA5MDQvRFREL3N2ZzEwLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4wIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiB3aWR0aD0iNTEyLjAwMDAwMHB0IiBoZWlnaHQ9IjUxMi4wMDAwMDBwdCIgdmlld0JveD0iMCAwIDUxMi4wMDAwMDAgNTEyLjAwMDAwMCIKIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiPgoKPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsNTEyLjAwMDAwMCkgc2NhbGUoMC4xMDAwMDAsLTAuMTAwMDAwKSIKZmlsbD0iIzAwMDAwMCIgc3Ryb2tlPSJub25lIj4KPHBhdGggZD0iTTEyMDIgNDQ2NSBjLTI4IC0xMiAtMzY3IC0zNTAgLTEwMTQgLTEwMTEgLTE2NSAtMTY5IC0xNzcgLTE4MyAtMTgzCi0yMjYgLTQgLTI4IC0yIC02MSA1IC04MiAxNSAtNDUgMTE0MiAtMTE5NCAxMTkyIC0xMjE1IDQ0IC0xOCAxMTggLTEwIDE1NSAxNwo1OSA0MiA4MSAxMzggNDcgMjA0IC05IDE3IC0yMDYgMjIyIC00MzcgNDU3IGwtNDIyIDQyNiAxMjc3IDUgYzEyNzAgNSAxMjc3IDUKMTMwNCAyNiA5MyA2OSA5NiAxOTMgNiAyNjIgbC0zNSAyNyAtMTI3MyA1IC0xMjczIDUgNDI0IDQzMiBjMjM0IDIzNyA0MzAgNDQ0CjQzNSA0NTggMzggMTAwIC0yOCAyMTIgLTEzMSAyMjEgLTI2IDMgLTU4IC0yIC03NyAtMTF6Ii8+CjxwYXRoIGQ9Ik0zNzgyIDMxODMgYy0xOCAtOSAtNDIgLTI5IC01NCAtNDYgLTI5IC00MSAtMzYgLTEyMyAtMTQgLTE2NiA5IC0xNwoyMDcgLTIyNCA0MzkgLTQ1OSBsNDIyIC00MjcgLTEyNzcgLTUgYy0xMjcwIC01IC0xMjc3IC01IC0xMzA0IC0yNiAtOTMgLTY5Ci05NiAtMTkzIC02IC0yNjIgbDM1IC0yNyAxMjc0IC01IDEyNzMgLTUgLTQyNSAtNDMyIGMtMjM0IC0yMzcgLTQzMCAtNDQ0Ci00MzUgLTQ1OCAtNDggLTEyNyA2NSAtMjU0IDE5MiAtMjE1IDM0IDEwIDEwOSA4MSA0NjcgNDQzIDc2NiA3NzYgNzM4IDc0Nwo3NDYgNzk5IDQgMjggMiA2MSAtNSA4MyAtMTUgNDYgLTExNDcgMTE5OCAtMTE5MyAxMjE1IC00MyAxNSAtOTcgMTIgLTEzNSAtN3oiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('my-output',{attrs:{"findText":_vm.findText,"ansText":_vm.ansText,"mark1":_vm.mark1,"mark2":_vm.mark2,"mode":_vm.mode},on:{"updateMode":_vm.updateMode}}),_vm._v(" "),(_vm.mode)?_c('div',{attrs:{"id":"calc"}},[_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.arrow)?_c('div',{staticClass:"move",attrs:{"id":"more_hide"},on:{"click":_vm.moreHide}},[_c('img',{class:{toCommon: _vm.classSwitch, toMore: !(_vm.classSwitch)},attrs:{"src":__webpack_require__(51),"alt":"open","id":"arrow"}})]):_vm._e()]),_vm._v(" "),_c('my-main',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.showOne),expression:"showOne"}],ref:"main",attrs:{"fix":_vm.fix,"findText":_vm.findText},on:{"update":_vm.update}},'my-main',_vm.config,false)),_vm._v(" "),_c('transition',{attrs:{"name":"slide","appear":""}},[(_vm.pc)?_c('more',_vm._b({on:{"update":_vm.update,"opAdd":_vm.opAdd}},'more',_vm.config,false)):_vm._e()],1)],1):_c('div',{attrs:{"id":"convCont"}},[_c('transition',{attrs:{"name":"slide-fade","appear":""}},[_c('converter',_vm._b({attrs:{"findText":_vm.findText,"total":_vm.total,"val1":_vm.val1,"val2":_vm.val2,"mark1":_vm.mark1,"mark2":_vm.mark2},on:{"update":_vm.update,"updateVal":_vm.updateVal,"updateT":_vm.updateTotal}},'converter',_vm.config,false))],1),_vm._v(" "),_c('my-main',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.showOne),expression:"showOne"}],ref:"main",attrs:{"fix":_vm.fix,"findText":_vm.findText},on:{"update":_vm.update}},'my-main',_vm.config,false)),_vm._v(" "),(_vm.pc)?_c('more',_vm._b({on:{"update":_vm.update,"opAdd":_vm.opAdd}},'more',_vm.config,false)):_vm._e()],1),_vm._v(" "),_c('div',{attrs:{"id":"copy"}},[_vm._v("Скопировано")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDIwMDEwOTA0Ly9FTiIKICJodHRwOi8vd3d3LnczLm9yZy9UUi8yMDAxL1JFQy1TVkctMjAwMTA5MDQvRFREL3N2ZzEwLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4wIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiB3aWR0aD0iMjI2OC4wMDAwMDBwdCIgaGVpZ2h0PSIxMjg1LjAwMDAwMHB0IiB2aWV3Qm94PSIwIDAgMjI2OC4wMDAwMDAgMTI4NS4wMDAwMDAiCiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCBtZWV0Ij4KCjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLDEyODUuMDAwMDAwKSBzY2FsZSgwLjEwMDAwMCwtMC4xMDAwMDApIgpmaWxsPSIjMDAwMDAwIiBzdHJva2U9Im5vbmUiPgo8cGF0aCBkPSJNNTY2NyA3MTcyIGwtNTY2NyAtNTY2NyA0MzggLTQzOCBjMjQwIC0yNDAgNDQwIC00MzcgNDQzIC00MzcgNCAwCjE0NiAtMTQwIDMxNiAtMzEyIGwzMTAgLTMxMSAzNTc0IDM1NjkgYzMyNjkgMzI2NCA0Mzg5IDQzNzcgNTc5MyA1NzU5IGw0OTgKNDg5IDQ5MDMgLTQ5MDkgNDkwMyAtNDkxMCA3NTEgNzUwIDc1MSA3NTAgLTU2NjcgNTY2NyBjLTMxMTggMzExOCAtNTY3MCA1NjY4Ci01NjczIDU2NjggLTMgMCAtMjU1NSAtMjU1MCAtNTY3MyAtNTY2OHoiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(53);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: 'history',
	routes: [{
		path: '/'
	}, {
		path: '*',
		redirect: '/'
	}]
}));

/***/ }),
/* 53 */,
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[16]);


// WEBPACK FOOTER //
// static/js/app.95585ac8707dbd8be841.js